var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-8"},[_c('dashboard-property',{attrs:{"property":_vm.property,"section_route":_vm.section_route}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }